import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const {
    REACT_APP_BASE_URL_GIS_SERVER} = window['runConfig'];

export const getLengthBySize = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_PIPELINES_V1/MapServer/2/Query`;

            const bodyFormData_getLengthBySize = new FormData();
            bodyFormData_getLengthBySize.set('f', 'json');
            const outStatistics = [{
                "statisticType": "sum",
                //"onStatisticField": "LENGTH_KM",
                "onStatisticField": "SHAPE.STLength()/1000",
                "outStatisticFieldName": "LenghtOfMeterSize"
            }];
            bodyFormData_getLengthBySize.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getLengthBySize.append('groupByFieldsForStatistics', 'TYPE, NOMINALDIAMETER');
            bodyFormData_getLengthBySize.append('outFields', 'TYPE, NOMINALDIAMETER');
            bodyFormData_getLengthBySize.append('orderByFields', 'TYPE ASC, NOMINALDIAMETER ASC');

            bodyFormData_getLengthBySize.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getLengthBySize,
            })

        });

    return res;
}